import { Component, OnInit } from '@angular/core';
import { MainService } from '../../mainservices/mainservices.model';
import { SubServices } from '../subservices.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MainserviceService } from '../../mainservices/mainservice.service';
import { SubservicesService } from '../subservices.service';
import { Globle } from 'src/assets/globle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-subserviceform',
  templateUrl: './subserviceform.component.html',
  styleUrls: ['./subserviceform.component.css']
})
export class SubserviceformComponent implements OnInit {

  //#region variables
  MainService: MainService[] = [];
  subService: SubServices = {} as SubServices;
  mainServiceObj: MainService = {} as MainService;
  updateMode = false;
  imagPath: any;
  files = [];
  spinnerOverlay = false;
  _submit = false;
  language!: number;
  mainServiceType!: number;
  //#endregion

  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: '500px',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter text here...',
  //   defaultParagraphSeparator: '',
  //   defaultFontName: '',
  //   defaultFontSize: '',
  //   fonts: [
  //     { class: 'arial', name: 'Arial' },
  //     { class: 'times-new-roman', name: 'Times New Roman' },
  //     { class: 'calibri', name: 'Calibri' },
  //     { class: 'comic-sans-ms', name: 'Comic Sans MS' }
  //   ],
  //   customClasses: [
  //     {
  //       name: 'quote',
  //       class: 'quote',
  //     },
  //     {
  //       name: 'redText',
  //       class: 'redText'
  //     },
  //     {
  //       name: 'titleText',
  //       class: 'titleText',
  //       tag: 'h1',
  //     },
  //   ],

  //   //uploadWithCredentials: false,
  //   sanitize: true,
  //   toolbarPosition: 'top',
  //   toolbarHiddenButtons: [
  //     ['bold', 'italic'],
  //     ['fontSize']
  //   ]
  // };

  config = {
    placeholder: 'aaaaa',
    tabsize: 2,
    height: 200,
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
  }

  constructor(private router: Router,
    private mainServiceService: MainserviceService,
    private service: SubservicesService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.language = this.localStorage.retrieve("lang");
    this.getMainService();
    this.getUrlParam();
  }

  ngAfterViewInit(): void {
    this.loaddropify();

  }

  getMainService() {
    this.spinnerOverlay = true;
    this.mainServiceService.getAll(true).subscribe(data => {
      this.MainService = data;
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  onSelectMainCategory() {
    this.mainServiceObj = {} as MainService
    this.mainServiceObj = this.MainService.find(x => x.id == this.subService.mainId) ?? {} as MainService;
    if (this.mainServiceObj.type == 2) {
      this.subService.costPrice = 0;
      this.subService.price = 0;
    }

  }

  onCommissionTypeChange() {
    if (this.subService.commissionType != 1) {
      this.subService.commissionPercent = 0;
    }
  }

  private prepareSubServicePayload(): SubServices {
    const payload = { ...this.subService };
    if (this.mainServiceObj.type == 2 && payload.commissionType != 1) {
      payload.commissionPercent = 0;
    }
    delete (payload as any).mainServices;
    return payload;
  }

  loaddropify() {
    var drEvent = $('.dropify').dropify();

    drEvent.on('dropify.afterClear', () => {
      this.subService.imgUrl = ""
    });

  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.subService.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.service.getById(this.subService.id).subscribe(data => {
      console.log(data)
      this.mainServiceObj = data.mainServices
      this.subService = data
      this.fillDropifyImage(this.imagPath + this.subService.imgUrl);
    })
  }

  back() {
    this.router.navigate(["./master/services/subservicelist"]);
  }

  submit() {

    if (this.mainServiceObj.type == 1) {
      if (this.subService.price.toString() == "" ||
        this.subService.price == null ||
        this.subService.price == 0) {
        this.openSnackBar("الرجاء ادخال السعر", 'snackBarError');
        return;
      }
      if (this.subService.costPrice.toString() == "" ||
        this.subService.costPrice == null ||
        this.subService.costPrice == 0) {
        this.openSnackBar("الرجاء ادخال سعر الكلفة", 'snackBarError');
        return;
      }
    }
    else if (this.subService.commissionType == 1) {
      if (this.subService.commissionPercent?.toString() == "" ||
        this.subService.commissionPercent == null ||
        this.subService.commissionPercent == 0) {
        this.openSnackBar("الرجاء ادخال النسبة", 'snackBarError');
        return;
      }
    }

    this.spinnerOverlay = true;
    if (this.files.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  create() {

    this.service.Create(this.prepareSubServicePayload()).subscribe(data => {
      this.spinnerOverlay = false;
      this._submit = true;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.prepareSubServicePayload()).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  onSelectImage(files: any) {
    this.files = files.target.files;
  }

  uploadImage() {

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service.upload(formData).subscribe(data => {

      this.subService.imgUrl = data['dbPath'];

      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('.dropify').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  // addNew() {
  //   this.subCategory.arabicName = "";
  //   this.subCategory.englishName = "";
  //   this.subCategory.cardsHowToUse = "";
  //   this.fillDropifyImage(null);
  //   this._submit = false;
  // }

}
